import { logger } from '@gem/modules/logger';
import { IStorageSessionCredentials } from '@gem/modules/remote-storage';

import { buildModelError } from 'APP/model/error/errorBuilder';
import { getFileStorageSessionCredentialsRequest } from 'APP/wsApi/wsAppApi/requests/fileStorageRequests';

import { mapStorageSessionCredentialsResponse } from './fileStorageModel.mapper';

export async function getStorageSessionCredentials(): Promise<IStorageSessionCredentials> {
  try {
    const response = await getFileStorageSessionCredentialsRequest();
    if (response.type.case === 'success' && response.type.value.credentials) {
      return mapStorageSessionCredentialsResponse(response.type.value.credentials);
    } else {
      throw response.type.value;
    }
  } catch (error) {
    logger.get('API').error('storage.getStorageSessionCredentialsRequest', error);
    throw buildModelError(error);
  }
}
